import type { components } from 'admination-react/api-schema'
import { getJson } from '@/core/api/http'

type Schemas = components['schemas']

export type Aktenplan = Schemas['AktenplanRead']

const MALFORMED = 'Die Antwort des Servers hatte nicht die erwartete Form.'

function isRecord(value: unknown): value is Record<string, unknown> {
  return !!value && typeof value === 'object' && !Array.isArray(value)
}

function isRegister(value: unknown): value is Aktenplan['register'][number] {
  if (!isRecord(value)) return false
  const { nummer, name, dokumente } = value
  return Number.isInteger(nummer) && typeof name === 'string' && Array.isArray(dokumente) && dokumente.every((d) => typeof d === 'string')
}

function isAktenplan(body: unknown): body is Aktenplan {
  return isRecord(body) && Array.isArray(body.register) && body.register.every(isRegister) && Number.isInteger(body.teilnehmerakte_register)
}

export async function getAktenplan(): Promise<Aktenplan> {
  const body = await getJson<unknown>('/variants/vergabe/aktenplan')
  if (!isAktenplan(body)) throw new Error(MALFORMED)
  return body
}
